import { _ as d, k as n, L as m, l as i } from "./main-DWIJXwA4.js";
import { createElementBlock as r, openBlock as l, Fragment as p, renderList as u, normalizeClass as h, createElementVNode as s, toDisplayString as a } from "vue";
const _ = {
  name: "ThemeControl",
  props: {
    modelValue: {
      type: String,
      required: !0,
      default: n
    }
  },
  data() {
    return {
      themeOptions: [n, m, i]
    };
  },
  computed: {
    themeSelected() {
      return this.modelValue;
    }
  },
  methods: {
    onSelectTheme(t) {
      this.$emit("update:modelValue", t);
    }
  }
};
function T(t, E, f, k, c, o) {
  return l(), r("div", { class: "inline-control space-between gap-10" }, [
    (l(!0), r(p, null, u(c.themeOptions, (e) => (l(), r("div", {
      key: e,
      class: h([[e, { selected: o.themeSelected === e }], "theme"]),
      onClick: (v) => o.onSelectTheme(e)
    }, [
      s("div", { class: "theme-example" }, a(t.$t("builder.controls.theme.aUppercase")), 1),
      s("div", { class: "name" }, a(t.$t(`builder.controls.theme.${e}`)), 1)
    ], 10, ["onClick"]))), 128))
  ]);
}
const b = /* @__PURE__ */ d(_, [["render", T], ["__scopeId", "data-v-4d9bdb16"]]);
export {
  b as T
};
